// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__rqfDXwSN6BgbOJAJZC8s2","name":"style_name__2P7_BksffrVb7AO7D_W4-r","description":"style_description__31NH9btBnF7hWHoEnHCn_Y"};